import dynamic from 'next/dynamic'
import { FC, useMemo, useReducer } from 'react'
// @ts-ignore
import { ThemeProvider } from '@emotion/react'

import {
    initialWarningState,
    warningReducer,
    WarningContext,
} from 'nexchange-service/module/common'
import { IntercomProvider } from 'intercom-service'

import theme from '@/src/theme'
import styled from '@emotion/styled'

import Footer from '@/components/Footer/PageFooter'
import PageHeader from '@/components/Header/PageHeader'
import { requestGeoLocationNextApi } from '@/services/location/api'
import { useGeoLocationData } from 'utility-tools/module/location'

const Warning = dynamic(() => import('@/globalComponents/Warning'))

const PageBodyContainer = styled.div`
    overflow: auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #242f3f;
`

const PageContentContainer = styled.div`
    height: 100%;
    margin: 0;
    flex-grow: 1;
    overflow: hidden;

    @media (min-width: ${props => props.theme.bps.md}) {
        margin: 0;
    }
    @media (min-width: ${props => props.theme.bps.lg}) {
        margin: 0rem 0rem;
    }
    @media (min-width: ${props => props.theme.bps.xl}) {
        margin: 0rem;
    }

    > * {
        max-width: 100%;
    }
`

const Layout: FC = ({ children }) => {
    const [warningState, dispatchWarningAction] = useReducer(warningReducer, initialWarningState)

    const warningContextValue = useMemo(
        () => ({ state: warningState, dispatchAction: dispatchWarningAction }),
        [warningState],
    )

    const { locationData } = useGeoLocationData(requestGeoLocationNextApi)
    const countryCode = locationData?.countryCode

    return (
        <ThemeProvider theme={theme}>
            <IntercomProvider />
            <WarningContext.Provider value={warningContextValue}>
                <PageBodyContainer>
                    <Warning />

                    <PageHeader />

                    <PageContentContainer id="page-content-container">
                        {/* @ts-ignore */}
                        {children}
                    </PageContentContainer>

                    <Footer />
                </PageBodyContainer>
            </WarningContext.Provider>
        </ThemeProvider>
    )
}

export default Layout
